import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiResponse } from '../dto/api-response.response';
import { CategoryRequest } from '../dto/category.request';
import { CategoryResponse } from '../dto/category.response';

@Injectable({ providedIn: 'root' })
export class CategoryService {
    private readonly baseUrl = `${environment.apiUrl}/categories`;

    constructor(private http: HttpClient) {}

    getAll(status?: number): Observable<ApiResponse<CategoryResponse[]>> {
        let params = new HttpParams();
        if (status !== undefined) params = params.set('status', status);
        return this.http.get<ApiResponse<CategoryResponse[]>>(this.baseUrl, { params });
    }

    create(req: CategoryRequest): Observable<ApiResponse<CategoryResponse>> {
        return this.http.post<ApiResponse<CategoryResponse>>(this.baseUrl, req);
    }

    update(id: number, req: CategoryRequest): Observable<ApiResponse<CategoryResponse>> {
        return this.http.put<ApiResponse<CategoryResponse>>(`${this.baseUrl}/${id}`, req);
    }

    updateStatus(id: number, status: number): Observable<ApiResponse<void>> {
        return this.http.patch<ApiResponse<void>>(`${this.baseUrl}/${id}/status`, { status });
    }
}
